<div class="spinner">
  <div class="app-loading-wrapper">
    <div class="app-loading" [class]="{ 'app-loading--blue': blue() }">
      <div [class]="{ logo: !blue(), 'logo--blue': blue() }"></div>
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
      </svg>
    </div>
  </div>
</div>
